var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"enum-text"},[_vm._v(_vm._s(_vm.$tools.getLabelByValue(_vm.value / 1, _vm.allEnumListMap[_vm.dicCode])))])}
var staticRenderFns = []

export { render, staticRenderFns }